var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.295 12.39a1.245 1.245 0 00.378.904v6.048a.666.666 0 00.665.657.659.659 0 00.657-.657V14.18l1.585 1.585v1.577a.657.657 0 001.314.005v-1.853a.66.66 0 00-.189-.46l-1.84-1.84v-2.627l.436.59a.466.466 0 00.393.214h1.85a.463.463 0 00.458-.465.458.458 0 00-.459-.455h-1.618l-1.34-1.832a1.232 1.232 0 00-1.718-.27L16.84 9.823a.454.454 0 00-.187.367v1.913a.466.466 0 00.468.46.457.457 0 00.452-.46V10.42l.723-.525zm1.763-4.835a1.316 1.316 0 10-1.685-.792 1.316 1.316 0 001.685.792zm-8.636 3.859a1.316 1.316 0 10-.792-1.685 1.316 1.316 0 00.792 1.685zM9.81 16.49l.859-.88.001 7.727a.658.658 0 001.317 0v-2.804l1.283 1.274a.658.658 0 00.93-.931l-2.228-2.212.872-.836a1.279 1.279 0 00.393-.922v-3.148l.701.512-.004 1.518a.46.46 0 00.92.002l.004-1.75a.46.46 0 00-.213-.392l-1.926-1.409a1.29 1.29 0 00-2.05 1.04v1.016l-1.56 1.6a.46.46 0 00.7.597l.001-.002z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21 19v2h-4v2h-4v1.986H9v1.031l5.003-.028-.007-1.993L18 24l-.016-2H22l.031-2H26v-1h-5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 3A13 13 0 113 16 13 13 0 0116 3m0-1a14 14 0 1014 14A14 14 0 0016 2z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--stairs-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'StairsIcon';
export default Icon;